import React from 'react';
import p from './real_heart.gif';
import './Widgets.css';

export class RealHeartWidget extends React.Component {
  render() {
    return (
      <img alt={'something went wrong'} src={p} style={{height: '8em'}}></img>
    );
  }
}
